/* eslint-disable @typescript-eslint/no-unnecessary-type-parameters */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from 'react'

/**
 * This is an alternative to the native React.lazy function. The native React.lazy doesn't allow you to import a named component, it only works with export defaults. This function instead allows you to import a named component.
 *
 * @param factory - The factory function with the actual import statement of the component. It should return a promise of an object.
 * @param name - The name of the component you want to import.
 * @returns An object with a single property, the name of which is the value of the name parameter. The value of that property is a React.lazy component.
 */
export const lazyImport = <
  T extends React.ComponentType<any>,
  I extends { [K2 in K]: T },
  K extends keyof I,
>(
  factory: () => Promise<I>,
  name: K,
): I => {
  return Object.create({
    [name]: React.lazy(() =>
      factory().then((module) => ({ default: module[name] })),
    ),
  })
}
